export const reportStatusEn = {
  Created: 'Created',
  Error: 'Error',
  Processed: 'Done',
  Processing: 'Processing',
};

type TReportStatusTranslation = typeof reportStatusEn;

export const reportStatusRu: TReportStatusTranslation = {
  Created: 'В ожидании',
  Error: 'Ошибка',
  Processed: 'Готов',
  Processing: 'В обработке',
};
